
export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Briefing detalhado',
      description: 'Compreendemos suas necessidades, estilo e expectativas para o projeto.',
      icon: 'ri-questionnaire-line'
    },
    {
      number: '02',
      title: 'Apresentação de conceito e moodboard',
      description: 'Desenvolvemos o conceito visual e apresentamos referências estéticas.',
      icon: 'ri-palette-line'
    },
    {
      number: '03',
      title: 'Projeto técnico e renderizações 3D',
      description: 'Criamos plantas técnicas detalhadas e visualizações realistas.',
      icon: 'ri-building-line'
    },
    {
      number: '04',
      title: 'Aprovação e ajustes',
      description: 'Refinamos o projeto com base no seu feedback até a aprovação final.',
      icon: 'ri-checkbox-circle-line'
    },
    {
      number: '05',
      title: 'Entrega executiva e suporte à obra',
      description: 'Fornecemos documentação completa e acompanhamento durante a execução.',
      icon: 'ri-tools-line'
    }
  ];

  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Do sonho ao projeto: um processo sem surpresas
          </h2>
          <p className="text-lg text-[#3F3F3F] max-w-3xl mx-auto leading-relaxed mb-2">
            Cada cliente é acompanhado diretamente pela equipe técnica, do primeiro contato à entrega final.
          </p>
          <p className="text-lg text-[#3F3F3F] max-w-3xl mx-auto leading-relaxed">
            O processo é transparente, organizado e conduzido com respeito ao tempo e investimento do cliente.
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-white p-6 rounded-2xl shadow-lg text-center group hover:shadow-xl transition-shadow duration-300">
              {/* Number */}
              <div className="w-12 h-12 bg-[#5C1A24] text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                {step.number}
              </div>
              
              {/* Icon */}
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-4">
                <i className={`${step.icon} text-2xl text-[#5C1A24]`}></i>
              </div>
              
              {/* Content */}
              <h3 className="font-bold text-[#3F3F3F] mb-3 text-sm leading-tight">
                {step.title}
              </h3>
              <p className="text-xs text-[#3F3F3F] leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Text */}
        <div className="text-center">
          <p className="text-lg text-[#5C1A24] font-medium" style={{ fontFamily: '"Playfair Display", serif' }}>
            Um processo leve, sem estresse e com resultado de alto nível.
          </p>
        </div>
      </div>
    </section>
  );
}
